export default __webpack_public_path__ + "static/media/ic_turkey.7e90915f.svg";